/**
 * Gravity Forms — Home Header Form Overlap Compensation
 *
 * On the homepage, the form inside `.home-header` can exceed
 * the header's reserved 330 px of visible space. This script
 * measures the form's actual height and pushes the next section
 * down by the overflow amount so content never hides behind it.
 */

const HEADER_FORM_BUDGET_PX = 330;
const POLL_INTERVAL_MS = 100;
const POLL_MAX_MS = 3000;

function compensateFormOverlap(): void {
	const form = document.querySelector<HTMLElement>('.home-header form');
	if (!form) return;

	const nextSection = document.querySelector<HTMLElement>('.home-header + *');
	if (!nextSection) return;

	const formHeight = form.getBoundingClientRect().height;

	// Bail if the form hasn't painted yet (height 0)
	if (formHeight === 0) return;

	const overflow = Math.max(0, formHeight - HEADER_FORM_BUDGET_PX);
	nextSection.style.paddingTop = overflow > 0 ? `${overflow}px` : '';
}

/**
 * Poll until the form is in the DOM with a real height,
 * then run the compensation. Covers async GF rendering.
 */
function waitForFormThenCompensate(): void {
	const start = Date.now();

	const check = (): void => {
		const form = document.querySelector<HTMLElement>('.home-header form');

		if (form && form.getBoundingClientRect().height > 0) {
			compensateFormOverlap();
			return;
		}

		if (Date.now() - start < POLL_MAX_MS) {
			setTimeout(check, POLL_INTERVAL_MS);
		}
	};

	check();
}

// Run after all resources (images, iframes, scripts) have loaded
window.addEventListener('load', waitForFormThenCompensate);

// Re-calculate on resize
window.addEventListener('resize', compensateFormOverlap);

// GF fires this after each multi-step page renders
document.addEventListener('gform_page_loaded', waitForFormThenCompensate);

// GF's own "form is fully rendered" event (jQuery-based)
try {
	(window as any).jQuery?.(document).on(
		'gform_post_render',
		() => waitForFormThenCompensate()
	);
} catch {
	// jQuery not available — covered by the other listeners
}

